/* eslint-disable react/no-children-prop */
import { Spinner } from 'reactstrap';
import { CheckboxInput, SelectInput } from '@/shared/ui';
import { ADD_NEW_EVENT_TYPE_BEAT_HR_TAB_OPTIONS, TYPE_RHYTHM_EVENT_ENUM } from '@/shared/config';
import EventRangePickers from './eventRangePickers';
import useAddNewEvent from './useAddNewEvent';

export type AddNewEventProps = {
  // this component's own propTypes declared onCancel as PropTypes.bool.isRequired, but it is
  // always called as a function (props.onCancel(isOpenNewEvent)) - pre-existing propTypes bug.
  onCancel: (isOpenNewEvent?: boolean) => void;
  ecgDataMap: any;
  timezone?: any;
  timezoneOffset: number;
  studyId: string;
  profileId: string;
  startReport: any;
  stopReport: any;
};

/**
 * Renders the draggable modal for adding a new rhythm event on the beat tab. Offers the event-type select, locked unless the AFib tab is active, reveals a use-all-available-time checkbox once AFib is chosen, embeds the start and end range pickers with their validation errors, and shows a spinner on the Add button while saving.
 *
 * @param props - Modal props forwarded to the add-new-event hook.
 * @returns The rendered add-event modal body with its cancel and add buttons.
 */
const AddNewEvent = ({
  onCancel,
  ecgDataMap,
  timezone,
  timezoneOffset,
  studyId,
  profileId,
  startReport,
  stopReport,
}: AddNewEventProps) => {
  const {
    activeButton,
    state,
    onChangeEvent,
    onChangeCheckbox,
    onChange,
    onClickCancel,
    onClickAdd,
  } = useAddNewEvent({
    onCancel,
    ecgDataMap,
    timezone,
    timezoneOffset,
    studyId,
    profileId,
    startReport,
    stopReport,
  });

  return (
    <div id="add-event">
      <div className="draggable-modal-content">
        <div className="content-title">Add new event</div>
        <div className="content">
          <SelectInput
            className="w-100 mb-3"
            name="eventType"
            label="Event type"
            options={ADD_NEW_EVENT_TYPE_BEAT_HR_TAB_OPTIONS}
            placeholder="Select event"
            value={state.eventType}
            disabled={activeButton !== TYPE_RHYTHM_EVENT_ENUM.AFIB}
            onChange={onChangeEvent}
          />
          {state.eventType?.value === TYPE_RHYTHM_EVENT_ENUM.AFIB && (
            <CheckboxInput
              id="isUse100Afib"
              checked={state.isUse100Afib}
              className="w-100 mb-3"
              name="isUse100Afib"
              onChange={onChangeCheckbox}
              data={
                {
                  label: 'Use 100% available time',
                  value: !state.isUse100Afib,
                } as any
              }
            />
          )}
          <EventRangePickers
            startDate={state.startDate}
            endDate={state.endDate}
            startTime={state.startTime}
            endTime={state.endTime}
            onChangePicker={onChange}
            error={state.errorObject}
          />
        </div>
      </div>
      <div className="footer-btn">
        <button
          id="cancel-event-beat-hr"
          className="draggable-modal-btn"
          onClick={() => {
            onClickCancel();
          }}
        >
          Cancel
        </button>
        <button
          disabled={state.isSaving}
          className="draggable-modal-btn btn-main"
          onClick={onClickAdd}
          id="add-event-beat-hr"
        >
          {state.isSaving ? <Spinner children="" /> : 'Add'}
        </button>
      </div>
    </div>
  );
};

export default AddNewEvent;
